<template>
  <div :class="{required:required}">
    <Cell is-link :title="title" :value="value || placeholder" @click="show=true"/>
    <Popup v-model="show" position="bottom" get-container="body">
      <DatetimePicker
          :value="new Date(value)"
          @confirm="onConfirm"
          @cancel="show=false"
          type="date"
          title="选择年月日"
      />
    </Popup>
  </div>
</template>

<script>
import {Popup, Cell, DatetimePicker} from "vant";


export default {
  name: "SelectDate",
  props: {
    title: String,
    value: String,
    required: Boolean,
    placeholder: String
  },
  data: function () {
    return {
      show: false,

      // minDate: new Date(2020, 0, 1),
      // maxDate: new Date(2025, 10, 1),
      // currentDate: new Date(2021, 0, 17),
    }
  },
  methods: {
    onConfirm(d) {
      this.$emit('input', `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDay()}`)
      this.show = false
    }
  },
  components: {Popup, Cell, DatetimePicker}
};
</script>
<style lang="scss" scoped>
.required {
  ::v-deep.van-cell__title {
    &::before {
      content: "*";
      color: #f44336;
    }
  }
}
</style>
